import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm';
import { useCanvasOffscreen } from '../CanvasOffscreen/canvas-offscreen';

export const Canvas: React.FC = () => {
  const theme = useLlm(state => state.theme);
  const ref = useRef<HTMLCanvasElement>(null);
  useCanvasOffscreen(ref);
  if (!theme.canvas?.enabled) {
    return;
  }
  return <canvas className="llm__canvas" ref={ref} aria-hidden={true} />;
};
